import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetClientsBySearchValue(club, searchValue) {

  var url = "/reservation/get_client_by_search_value/" + club + searchValue; 

  return FetchGetDataWithAuthNEW(url);
}